/**
 * AddMultiSetItemsCtrl controller
 * Crop image
 */

// controller mixins
AddMultiSetItemsCtrl.mixes = [
  'openPopupCtrlMixin'
]

// preload drag'n'drop image
const dragndropImg = new window.Image()
dragndropImg.src = require('./img/dragndrop.png')

/**
 * AddMultiSetItemsCtrl controller
 *
 * @class AddMultiSetItemsCtrl
 *
 * @ngdoc controller
 * @name mwApp/crop.controller:AddMultiSetItemsCtrl
 */
/* @ngInject */
export default function AddMultiSetItemsCtrl ($scope, $uibModalInstance, assignedItems, type, ms) {
  var vm = this
  vm.items = { assigned: assignedItems, available: [] }
  vm.type = type
  vm.label = ''
  let extraType
  switch (type) {
    case 'vod':
      extraType = 'vod-sets'
      vm.label = 'VOD'
      break
    case 'tvShow':
      extraType = 'tv-show-sets'
      vm.label = 'TV Show'
      break
    case 'liveEvent':
      extraType = 'live-event-sets'
      vm.label = 'Live Event'
      break
    case 'channel':
      extraType = 'channel-sets'
      vm.label = 'Channel'
      break
    default:
      extraType = 'channel-sets'
      vm.label = 'Channel'
      break
  }

  vm.defaultParams = {
    q: '',
    page: 0,
    last: false,
    count: 25
  }

  vm.getAvailableSets = function (page = 0) {
    ms._getAvailableItems(ms.networkId, extraType, { ...vm.defaultParams, page, q: vm.availableFilter }).then(res => {
      vm.items.available = res.content.filter(c => !vm.items.assigned.find(i => i.id === c.id))
      vm.params = { page: res.number, q: vm.availableFilter, last: res.last, count: res.size }
      vm.params.last = res.last
    })
  }
  vm.getAvailableSets()

  /**
   * Handler for scroll event of Available select list
   *
   * @param event
   */
  vm.$timerContentAvailableScroll = 0
  vm.contentCallbackAvailableScroll = (event) => {
    const {
      page,
      last
    } = vm.params
    if (!last && event.currentTarget.scrollTop >= (event.currentTarget.scrollHeight - event.currentTarget.clientHeight) * 0.6) {
      window.clearTimeout(vm.$timerContentAvailableScroll)
      vm.$timerContentAvailableScroll = window.setTimeout(() => {
        ms._getAvailableItems(ms.networkId, extraType, {
          count: 25,
          page: page + 1,
          q: vm.availableFilter
        }).then((result) => {
          const content = angular.copy(result.content)
          vm.params.last = result.last
          vm.params.page = result.number
          vm.items.available = vm.items.available.concat(content.filter(c => !vm.items.assigned.find(ia => ia.id === c.id)))
        })
      }, 700)
    }
  }

  /**
   * In the dnd-drop callback, we now have to handle the data array that we
   * sent above. We handle the insertion into the list ourselves. By returning
   * true, the dnd-list directive won't do the insertion itself.
   */
  vm.onDrop = function (list, type, items, index) {
    items.forEach(item => { item.selected = false })
    list[type] = list[type]
      .slice(0, index)
      .concat(items)
      .concat(list[type].slice(index))
    return true
  }

  /**
   * dnd-dragging determines what data gets serialized and send to the receiver
   * of the drop. While we usually just send a single object, we send the array
   * of all selected items here.
   */
  vm.getSelected = function (list, type, link) {
    link.selected = true
    return list[type].filter(link => link.selected)
  }
  /**
   * Delete Vod from vodSet
   *
   * @memberof mwApp/packages.controller:AddVodSetCtrl
   */
  vm.deleteVodFromSet = function (link) {
    link.selected = false
    vm.items.assigned = vm.items.assigned.filter(vod => vod.id !== link.id)
    vm.items.available.push(link)
  }

  /**
   * We set the list into dragging state, meaning the items that are being
   * dragged are hidden. We also use the HTML5 API directly to set a custom
   * image, since otherwise only the one item that the user actually dragged
   * would be shown as drag image.
   */
  vm.onDragstart = function (list, event) {
    list.dragging = true
    if (event.dataTransfer.setDragImage) {
      event.dataTransfer.setDragImage(dragndropImg, 0, 0)
    }
  }

  /**
   * We set the list into dragging state, meaning the items that are being
   * dragged are hidden. We also use the HTML5 API directly to set a custom
   * image, since otherwise only the one item that the user actually dragged
   * would be shown as drag image.
   */
  vm.onDragend = function (list) {
    list.dragging = false
  }

  /**
   * Last but not least, we have to remove the previously dragged items in the
   * dnd-moved callback.
   */
  vm.onMoved = function (list, type) {
    list[type] = list[type].filter(item => !item.selected)
  }

  $scope.$watch('vm.items.available', () => {
    if (vm.items.available.length <= 10) {
      if (vm.params && !vm.params.last) {
        ms._getAvailableItems(ms.networkId, extraType, {
          count: 25,
          page: vm.params.page + 1,
          q: vm.availableFilter
        }).then((result) => {
          const content = angular.copy(result.content)
          vm.params.last = result.last
          vm.params.page = result.number
          vm.items.available = vm.items.available.concat(content.filter(c => !vm.items.assigned.find(ia => ia.id === c.id)))
        })
      }
    }
  })

  vm.submit = function () {
    $uibModalInstance.close(vm.items.assigned)
  }

  /**
   * Cancel editing, close modal window
   *
   * @memberof mwApp/seasons.controller:AddMultiSetItemsCtrl
   */
  vm.cancel = function () {
    $uibModalInstance.dismiss('cancel')
  }
}
